import GSocket from '../../Utilities/Gnural/websockets';

export function leaveContext() {
	return (dispatch) => {
		GSocket.publish('leavecontext', {});
		dispatch({ type: 'ON_WEBSOCKET_LEAVE_CONTEXT' });
	};
}

export function changeContext(contextGuid) {
	return (dispatch) => {
		GSocket.publish('changecontext', {context: contextGuid});
		dispatch({ type: 'ON_WEBSOCKET_CHANGE_CONTEXT', payload: contextGuid });
	};
}

export function contextSignal(sender, senderId, recipient, message) {
	return (dispatch) => {
		if (senderId) {
			GSocket.publish('contextsignal', {sender, senderId, recipient, message});
		} else {
			GSocket.publish('contextsignal', {sender, recipient, message});
		}
		dispatch({ type: 'ON_WEBSOCKET_CONTEXT_SIGNAL', payload: {sender, senderId, recipient, message} });
	};
}

export function getContext() {
	return (dispatch) => {
		GSocket.publish('GetContext');
		dispatch({ type: 'ON_WEBSOCKET_GET_CONTEXT' });
	};
}

export function offerContext(PeerId) {
	return (dispatch) => {
		GSocket.publish('offercontext', {PeerId});
		dispatch({ type: 'ON_WEBSOCKET_OFFER_CONTEXT', payload: PeerId });
	};
}

export function denyContext(PeerId) {
	return (dispatch) => {
		GSocket.publish('denycontext', {PeerId});
		dispatch({ type: 'ON_WEBSOCKET_DENY_CONTEXT', payload: PeerId });
	};
}

export function disconnectPeer(RecipientPeerId) {
	return (dispatch) => {
		GSocket.publish('DisconnectPeer', { Recipient: RecipientPeerId });
		dispatch({ type: 'ON_WEBSOCKET_DISCONNECT_PEER', payload: { Recipient: RecipientPeerId }});
	};
}

export function remoteTrackAdded() {
	return (dispatch) => {
		dispatch({ type: 'ON_REMOTE_TRACK_ADDED' });
	};
}